// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"efb45e85","146":"2d1dfeac","157":"bb50fd68","187":"7e7c8896","203":"efb49618","285":"19ffb1d2","312":"de668dbc","386":"3196965a","453":"ea025e36","556":"eac69b0a","746":"6a48d03c","779":"fc75a924","904":"a3408330"}[chunkId] + ".chunk.js";
};